import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useUserSession } from "../../hooks/useUserSession";
import { hasActiveCare } from "../../utils/careAccess";

const ActiveCareGuard = () => {
  const { loading, userDetails, setUserDetails } = useUserSession();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <CircularProgress color="success" />
      </Box>
    );
  }

  if (!hasActiveCare(userDetails)) {
    return (
      <Navigate
        to="/user/unlock-dashboard"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return <Outlet context={{ userDetails, setUserDetails }} />;
};

export default ActiveCareGuard;
